const API_BASE = import.meta.env.VITE_API_URL || '';

let csrfToken: string | null = null;

export function setCsrf(token: string) {
  csrfToken = token;
}

export async function apiCall<T>(
  path: string,
  options: RequestInit = {}
): Promise<{ success: boolean; data?: T; error?: string }> {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    ...(options.headers as Record<string, string>),
  };

  if (csrfToken && ['POST', 'PUT', 'DELETE', 'PATCH'].includes(options.method || 'GET')) {
    headers['X-CSRF-Token'] = csrfToken;
  }

  const response = await fetch(`${API_BASE}/api/v1${path}`, {
    ...options,
    headers,
    credentials: 'include',
  });

  if (response.status === 401) {
    // Try to refresh
    const refreshRes = await fetch('/api/v1/auth/refresh', {
      method: 'POST',
      credentials: 'include',
    });
    if (refreshRes.ok) {
      const refreshData = await refreshRes.json();
      if (refreshData.data?.csrfToken) {
        csrfToken = refreshData.data.csrfToken;
        headers['X-CSRF-Token'] = csrfToken!;
      }
      // Retry original request
      const retryRes = await fetch(`${API_BASE}/api/v1${path}`, { ...options, headers, credentials: 'include' });
      return retryRes.json();
    }
    window.location.href = '/login';
    throw new Error('Session expired');
  }

  return response.json();
}
